import { Component, ElementRef, AfterViewInit, ViewChild, HostListener } from '@angular/core';

@Component({
  selector: 'app-home-video',
  templateUrl: './home-video.component.html',
  styleUrls: ['./home-video.component.scss']
})
export class HomeVideoComponent implements AfterViewInit {

  @ViewChild('targetSection') targetSection: ElementRef;
  scale: number = 1.1;
  lastScrollTop: number = 0;
  isSectionInView: boolean = false;

  ngAfterViewInit() {
    // const observer = new IntersectionObserver(entries => {
    //   entries.forEach(entry => {
    //     this.isSectionInView = entry.isIntersecting;
    //     console.log("this.isSectionInView",this.isSectionInView)
    //   });
    // });

    // observer.observe(this.targetSection.nativeElement);
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    let st = window.pageYOffset || document.documentElement.scrollTop;
    // console.log("observer",document.documentElement)
    // if (this.isSectionInView) {
    //   if (st === 0){
    //     this.scale = 1.1;
    //   }
    //   else if (st > this.lastScrollTop) {
    //     // Scroll down - faster scaling, but limit to 0.98
    //     this.scale = Math.max(0.9, this.scale - 0.01);
    //   } else {
    //     // Scroll up - slower scaling, but only when section is in view
    //     this.scale = Math.min(1.1, this.scale + 0.01);
    //   }
    // }

    // this.lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  }

}
